import { render, staticRenderFns } from "./SignupProvider.vue?vue&type=template&id=4ad10b1b&"
import script from "./SignupProvider.vue?vue&type=script&lang=js&"
export * from "./SignupProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports